import React from 'react';
import { Segment } from 'semantic-ui-react';
import { useParams, useSearchParams } from 'react-router-dom';

import { Menu } from 'src/components/custom';
import { PATH } from 'src/constants/app';
import { Key, MenuData } from 'src/components/custom/Menu/context';
import { getProgrammeBioNavigation } from 'src/utils/programmeBios';

type Props = {
  activeKey: Key;
  menu: MenuData[];
  bios?: Model.CislBio[];
};

const Materials: React.FC<Props> = ({ activeKey, menu, bios }) => {
  const { class_id } = useParams<{ class_id: string }>();
  const [searchParams] = useSearchParams();
  const { groups, activeGroup } = getProgrammeBioNavigation(
    bios,
    searchParams.get('category'),
  );
  const activeKeys = [activeKey];
  if (activeKey === 'programme-bios' && activeGroup) {
    activeKeys.push(`programme-bios-${activeGroup.category}`);
  }

  return (
    <Segment className="p-12">
      <div className="">
        <Menu
          menu={menu.flatMap((m) => {
            const item = {
              ...m,
              to: `/${PATH.CLASS}/${class_id}/${m.to}`,
            };
            if (m.key !== 'programme-bios' || activeKey !== 'programme-bios')
              return [item];

            return [
              item,
              ...groups.map(({ category, title }) => ({
                key: `programme-bios-${category}`,
                to: `${item.to}?category=${category}`,
                content: title,
                className: 'programme-bios-category',
              })),
            ];
          })}
          itemProps={{ className: 'fw-bold' }}
          activeKeys={activeKeys}
        />
      </div>
    </Segment>
  );
};

export default Materials;
